export { FaroRoutes } from './FaroRoutes';
export { createReactRouterV6Options, createReactRouterV6DataOptions, initializeReactRouterV6Instrumentation, initializeReactRouterV6DataRouterInstrumentation, } from './initialize';
export { setReactRouterV6SSRDependencies } from './routerDependencies';
export { withFaroRouterInstrumentation } from './withFaroRouterInstrumentation';
//# sourceMappingURL=index.js.map